export const ADD_RESULT_REQUEST = 'ADD_RESULT_REQUEST';
export const ADD_RESULT_SUCCESS = 'ADD_RESULT_SUCCESS';
export const ADD_RESULT_FAIL = 'ADD_RESULT_FAIL';

export const USER_RESULT_REQUEST = 'USER_RESULT_REQUEST';
export const USER_RESULT_SUCCESS = 'USER_RESULT_SUCCESS';
export const USER_RESULT_FAIL = 'USER_RESULT_FAIL';
